import React from 'react';

const CheckBoxApproval = ({ id, handleCheckboxChange, isChecked, isDisabled}) => (
    <input key={id} onClick={handleCheckboxChange} type="checkbox" checked={isChecked} disabled={isDisabled}/>
);

export default CheckBoxApproval;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/CheckBoxApproval.jsx